
import React,{useState} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Login from "./components/login";
import Signup from "./components/signup";
import Alert from "./components/Alert";
import About from "./components/About";
import NoteState from "./context/notes/NoteState";

function App() {
    const [alert, setAlert] = useState(null);
  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  };
  return (
    <>
      <NoteState>
        <Router>
          <Navbar />
          <Alert alert = {alert}/>
          <div className="container">
            <Routes>
              <Route exact path="/" element={<Home showAlert  = {showAlert} />} />
              <Route exact path="/About" element={<About />} />
              <Route exact path="/login" element={<Login showAlert  = {showAlert} />} />
              <Route exact path="/signup" element={<Signup showAlert  = {showAlert} />} />
            </Routes>
          </div>
        </Router>
      </NoteState>
    </>
  );
}

export default App;
